// extracted by mini-css-extract-plugin
export default {"contents":"GE-z","sectionHeading":"HE-z"};